// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moderationBroadcasterDisplayGlobal {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    padding-bottom: 1em;
    animation: fadeInGlobal 0.4s;
}

.moderatorCardDisplayContainer {
    position: relative;
    background-color: var(--DarkBlue);
    max-width: 20em;
    min-width: 15em;
    min-height: 15em;
    border-radius: 5px;
}

.LoadingDisplayModeratorCardDisplay {
    display: flex;
    justify-content: center;

    max-width: 15em;
    min-width: 15em;
    min-height: 15em;
    max-height: 15em;
}

.moderatorCardDisplayImage {
    max-height: 3em;
    width: 3em;
    height: 3em;
    border-radius: 50%;
    margin-top: auto;
    margin-bottom: auto;
}

.moderatorCardDisplayXButtonContainer {
    float: right;
    padding-right: 0.5em;
    padding-top: 0.8em;
}

.moderatorCardDisplayXButton {
    position: relative;
    font-size: 20px;
    z-index: 2;
    padding: 0.5em;
    border-radius: 5px;
    color: white;
    border: none;
    outline: none;
    background-color: var(--templatesColorBackgroundContainer);
    cursor: pointer;
}

.moderatorCardDisplayXButton:hover {
    background-color: var(--templatesColorBackgroundInContainer);
}

.moderatorCardDisplayImageNameContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    padding-left: 1em;
    padding-top: 0.5em;
    word-break: break-all;
}

.moderatorCardDisplayName {
    margin-top: auto;
    max-width: 14em;
    margin-bottom: auto;
    font-size: 12px;
}

.moderatorCardDisplayContainerApproveDeny {
    font-size: 12px;
    color: var(--Gray);
    justify-content: space-between;
}

.moderatorCardDisplayContainerApproveDenyDisabled {
    font-size: 12px;
    color: var(--Gray);
    justify-content: space-between;
    opacity: 0.3;
}

.moderatorCardDisplayHr {
    background-color: var(--Gray);
    height: 1px;
    border: none;
}

.moderatorCardDisplayPremissionsContainer {
    padding-bottom: 1em;
    transform: scale(0.7);
}

@media only screen and (max-width: 553px) {
    .moderationBroadcasterDisplayGlobal {
        justify-content: center;
    }
}

@media only screen and (max-width: 320px) {
    .moderatorCardDisplayImageNameContainer {
        justify-content: center;
    }

    .moderatorCardDisplayXButton {
        font-size: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Moderation/ModeratorList/ModerationListDisplay/ModerationCardDisplay/moderatorCardDisplay.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;;IAEvB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,0DAA0D;IAC1D,eAAe;AACnB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".moderationBroadcasterDisplayGlobal {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1em;\n    padding-bottom: 1em;\n    animation: fadeInGlobal 0.4s;\n}\n\n.moderatorCardDisplayContainer {\n    position: relative;\n    background-color: var(--DarkBlue);\n    max-width: 20em;\n    min-width: 15em;\n    min-height: 15em;\n    border-radius: 5px;\n}\n\n.LoadingDisplayModeratorCardDisplay {\n    display: flex;\n    justify-content: center;\n\n    max-width: 15em;\n    min-width: 15em;\n    min-height: 15em;\n    max-height: 15em;\n}\n\n.moderatorCardDisplayImage {\n    max-height: 3em;\n    width: 3em;\n    height: 3em;\n    border-radius: 50%;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.moderatorCardDisplayXButtonContainer {\n    float: right;\n    padding-right: 0.5em;\n    padding-top: 0.8em;\n}\n\n.moderatorCardDisplayXButton {\n    position: relative;\n    font-size: 20px;\n    z-index: 2;\n    padding: 0.5em;\n    border-radius: 5px;\n    color: white;\n    border: none;\n    outline: none;\n    background-color: var(--templatesColorBackgroundContainer);\n    cursor: pointer;\n}\n\n.moderatorCardDisplayXButton:hover {\n    background-color: var(--templatesColorBackgroundInContainer);\n}\n\n.moderatorCardDisplayImageNameContainer {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1em;\n    padding-left: 1em;\n    padding-top: 0.5em;\n    word-break: break-all;\n}\n\n.moderatorCardDisplayName {\n    margin-top: auto;\n    max-width: 14em;\n    margin-bottom: auto;\n    font-size: 12px;\n}\n\n.moderatorCardDisplayContainerApproveDeny {\n    font-size: 12px;\n    color: var(--Gray);\n    justify-content: space-between;\n}\n\n.moderatorCardDisplayContainerApproveDenyDisabled {\n    font-size: 12px;\n    color: var(--Gray);\n    justify-content: space-between;\n    opacity: 0.3;\n}\n\n.moderatorCardDisplayHr {\n    background-color: var(--Gray);\n    height: 1px;\n    border: none;\n}\n\n.moderatorCardDisplayPremissionsContainer {\n    padding-bottom: 1em;\n    transform: scale(0.7);\n}\n\n@media only screen and (max-width: 553px) {\n    .moderationBroadcasterDisplayGlobal {\n        justify-content: center;\n    }\n}\n\n@media only screen and (max-width: 320px) {\n    .moderatorCardDisplayImageNameContainer {\n        justify-content: center;\n    }\n\n    .moderatorCardDisplayXButton {\n        font-size: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
